import React from 'react';
import { connect } from 'react-redux';
import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { Icon,Form,Select,DatePicker,TimePicker,Input,Tooltip,Button,message } from 'antd';
import applicationCenterService from '../../services/Employee/application-center-service';

// import { Link } from 'react-router-dom';
const { TextArea } = Input;
class ApplySpecialBreakDown extends React.Component {
	submitApplyModal = () => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				let posts = {
					...values
				};
				if (values.start_date){
					posts.start_date = values.start_date.format('YYYY-MM-DD')
				}
				if (values.start_time){
					posts.start_time = values.start_time.format('HH:mm')
				}
				if (values.end_date){
					posts.end_date = values.end_date.format('YYYY-MM-DD')
				}
				if (values.end_time){
					posts.end_time = values.end_time.format('HH:mm')
				}
				// console.log(posts);
				applicationCenterService.addApplySpecialBreakDown(posts, res => {
					if (res.data.Success) {
						message.success("调休申请操作成功 Apply relaxation success", 4);
						this.props.form.resetFields();
					}else{
						message.error(`调休申请操作失败 Apply relaxation faild：${res.data.Errors[0]}`);
					}
				}, err => {});
			}
		})
	}
	render() {
		return (
			<div className="app-module-item">
				<div className="remindingImportant">调休申请 Apply Relaxation</div>
				<Form onSubmit={this.submitApplyModal} className="login-form long-label" layout="inline">
					<div className="Applys">
						<Form.Item label={(
				            <span>
				              <Tooltip>
				                <Icon type="question-circle-o" />
				              </Tooltip>
				              &nbsp;调休选择 Relaxation Type
				            </span>
				          )}>
							{this.props.form.getFieldDecorator('relaxation_type', {
								rules: [{ required: true, message: '请选择调休类型 Please Select Relaxation Type' }],
							})(<Select style={{width:"360px"}} onSelect={this.selectCertificate}>
								<Select.Option key={1} value={1} data="普通调休">普通调休 Normal</Select.Option>
								<Select.Option key={2} value={2} data="因公调休">因公调休 Business</Select.Option>
							</Select>)}
						</Form.Item>
					</div>
					<div className="ApplyDiv">
						<Form.Item label={(
				            <span>
				              <Tooltip>
				                <Icon type="calendar" />
				              </Tooltip>
				              &nbsp;开始时间 Start Time
				            </span>
				          )} style={{float:"left"}}>
							{this.props.form.getFieldDecorator('start_date', {
								rules: [{ required: true, message: '请输入调休开始日期' }],
							})(<DatePicker style={{width:"180px"}} />)}
						</Form.Item>
						<Form.Item lable=" " style={{float:"left",marginTop:"4px",marginLeft:"10px"}}>
							{this.props.form.getFieldDecorator('start_time', {
								rules: [{ required: true, message: '开始时间 Start Time' }],
							})(<TimePicker minuteStep={30} format="HH:mm" style={{width:"170px"}} />)}
						</Form.Item>
					</div>
					<div className="ApplyDiv">
						<Form.Item label={(
				            <span>
				              <Tooltip>
				                <Icon type="calendar" />
				              </Tooltip>
				              &nbsp;结束时间 End Time
				            </span>
				          )} style={{float:"left"}}>
							{this.props.form.getFieldDecorator('end_date', {
								rules: [{ required: true, message: '请输入调休结束日期' }],
							})(<DatePicker style={{width:"180px"}} />)}
						</Form.Item>
						<Form.Item lable=" " style={{float:"left",marginTop:"4px",marginLeft:"10px"}}>
							{this.props.form.getFieldDecorator('end_time', {
								rules: [{ required: true, message: '结束时间 End Time' }],
							})(<TimePicker minuteStep={30} format="HH:mm" style={{width:"170px"}} />)}
						</Form.Item>
					</div>
					
					<div className="ApplyDiv">
						<Form.Item label={(
				            <span>
				              <Tooltip>
				                <Icon type="file-text" />
				              </Tooltip>
				              &nbsp;调休事由 Relaxation Reason
				            </span>
				          )}>
							{this.props.form.getFieldDecorator('remark', {
								rules: [{ required: true, message: '请输入调休事由 Please Fill In Relaxation Reason' }],
							})(<TextArea rows={4} style={{display:'block',width:'360px'}}/>)}
						</Form.Item>
					</div>
					<div className="ApplySubmit">
						<Button type="primary"  onClick={this.submitApplyModal}>
							<Icon type="check" />
							<span>提交 Submit</span>
						</Button>
					</div>
					
				</Form>
			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
	}
}

const mapDispatchToProps = {
}

ApplySpecialBreakDown = Form.create()(ApplySpecialBreakDown);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(ApplySpecialBreakDown));


// WEBPACK FOOTER //
// ./src/routes/Employee/ApplySpecialBreakDown.js